<router-outlet></router-outlet>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>